var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contentArea"},[(_vm.page.type === 'table')?_c('div',[_c('AgGrid')],1):_vm._e(),(_vm.page.type === 'setting')?_c('div',[_c('settingRole')],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }